import { render, staticRenderFns } from "./SchoolSystemIconTeacherDialog.vue?vue&type=template&id=a5068f1a&scoped=true"
import script from "./SchoolSystemIconTeacherDialog.vue?vue&type=script&lang=js"
export * from "./SchoolSystemIconTeacherDialog.vue?vue&type=script&lang=js"
import style0 from "./SchoolSystemIconTeacherDialog.vue?vue&type=style&index=0&id=a5068f1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5068f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5068f1a')) {
      api.createRecord('a5068f1a', component.options)
    } else {
      api.reload('a5068f1a', component.options)
    }
    module.hot.accept("./SchoolSystemIconTeacherDialog.vue?vue&type=template&id=a5068f1a&scoped=true", function () {
      api.rerender('a5068f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SchoolSystemIconTeacherDialog.vue"
export default component.exports